module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-BoldItalic.woff2?784f969644f40b923cd794c5fd24dd08";